/*
 * @Author: wuhao
 * @Date: 2019-08-09 11:40:11
 * @LastEditors: lisf
 * @LastEditTime: 2021-07-12 14:47:01
 * @Description: 错误码拦截
 */
// import Vue from 'vue'
import { Message } from 'element-ui'

const errorIntercept = ({ code }) => {
    if (errorCodes[code]) {
        if (errorCodes[code].type === 'message') {
            Message({
                message: errorCodes[code].subTip,
                type: 'error'
            })
        }
    }
    return true
}

const errorCodes = {
    4001: {
        type: 'message',
        subTip: '用户不存在'
    },
    4002: {
        type: 'message',
        subTip: '密码错误'
    },
    4004: {
        type: 'message',
        subTip: '用户已禁用'
    },
    4009: {
        type: 'message',
        subTip: '第三方认证配置错误'
    },
    4011: {
        type: 'message',
        subTip: '短信验证码错误'
    }
}

export default errorIntercept



// WEBPACK FOOTER //
// ./src/api/errorMessage.js